import { RemoveVoid } from "../../../../../../common/common_utils";
import { RouterInferenceHelpers } from "../../../../../../src/api/trpc/rootRouter";
import { trpc } from "../../../utils/trpc";

export function useEventListQuery(
	params: RemoveVoid<RouterInferenceHelpers["event"]["list"]["input"]>
) {
	const context = trpc.useContext();

	return trpc.event.list.useQuery(params, {
		staleTime: 5000,
		keepPreviousData: true,
		onSuccess: (data) => {
			data.items.forEach((val) =>
				context.event.getListItem.setData(() => val, {
					guild_id: params.guild_id,
					message_id: val.message_id,
				})
			);
		},
	});
}
